import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=4d8d1b19&scoped=true"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=4d8d1b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d1b19",
  null
  
)

export default component.exports